import { IQuestionModel } from '@care-portals/api-interfaces';

const questionsModels: IQuestionModel[] = [
  {
    label: 'Consent to Disclose Personal Health Information',
    field: 'customerVirtuaCareCoordinators',
    type: 'info',
    educationalSlide: `Hello, 

    To access your medical information I will need to obtain your consent to do so.
    
    Please agree to the following statement:

    Consent to Disclose Personal Health Information Pursuant to the Personal Health Information Protection Act, 2004 (PHIPA) I, _________ , authorize Jack & Jill Health and its employees to review my personal health information consisting of:
     
      - Lab results
      - Medical notes
      - Demographic information
      - Medical history
      - Insurance cards
      - Prescription details
    
    I understand the purpose for disclosing this personal health information to the person noted above. I understand that I can refuse to sign this consent form.`,
    answer: {
      type: 'consent-check',
      label: 'I agree.',
      name: 'customerVirtuaCareCoordinatorsConsent'
    }
  }
];
export default questionsModels;
